"use client";

import { Button, Flex, Link, Text } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { LuArrowRight } from "react-icons/lu";

import OrSeparator from "@features/services/shipping/OrSeparator";
import TrackingNumberInput from "@features/services/shipping/TrackingNumberInput";

interface ShippingLandingViewProps {
  bookingOpen: boolean;
  onStartShipping: () => void;
  onSearchTracking: (trackingRef: string) => void;
}

const ShippingLandingView = ({
  bookingOpen,
  onStartShipping,
  onSearchTracking,
}: ShippingLandingViewProps) => {
  const [trackingNumber, setTrackingNumber] = useState("");

  const onSearch = useCallback(() => {
    const trimmed = trackingNumber.trim();
    if (trimmed === "") {
      return;
    }
    onSearchTracking(trimmed);
  }, [trackingNumber, onSearchTracking]);

  return (
    <Flex direction="column" align="center" gap="32px" p="40px 20px">
      <Flex direction="column" w="100%" maxW="400px" gap={2}>
        <TrackingNumberInput
          value={trackingNumber}
          onChange={setTrackingNumber}
          onSearch={onSearch}
        />
        <OrSeparator />
      </Flex>

      <Flex direction="column" w="100%" maxW="400px" gap={3}>
        {bookingOpen ? (
          <Button size="lg" w="100%" onClick={onStartShipping}>
            Start shipping with us
            <LuArrowRight />
          </Button>
        ) : (
          <Text fontSize="sm" color="text.secondary" textAlign="center">
            Booking is temporarily unavailable. Please check back soon, or
            reach us on WhatsApp below.
          </Text>
        )}
      </Flex>

      <Flex justify="center" mt={4}>
        <Text>
          If you want a full container, please{" "}
          <Link
            href="https://api.whatsapp.com/send?phone=233558239490"
            target="_blank"
            rel="noopener noreferrer"
            variant="underline"
            fontWeight="semibold"
          >
            contact us
          </Link>
        </Text>
      </Flex>
    </Flex>
  );
};

export default ShippingLandingView;
